import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';
import { round } from 'mathjs';

// import { newRate } from '@tool/index';

const moDifferent = observable({
  // 最多37个城市，最多3页
  list1: <any[]>[],
  lists: <any[]>[],
  cityModal: false,
});

const newRate = (value: any, digit: number = 1) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  if (value === 0) return 0;
  return round(value, digit);
};

const initDifferent = action((res: any) => {
  // console.log('城市薪酬差异系数 -- ', res);
  if (isEmpty(res)) return;

  let areaArr: any[] = [];
  const cityArr1: any[] = [];
  const tempArea: any[] = [];
  const lists: any[] = [];
  let res10: any[] = [];
  let res1: any[] = [];
  const newRes: any[] = [];
  const arr1: any[] = [];

  // 将 "全国" 过滤掉
  res.map((item: any) => {
    if (item.city_area !== '全国') newRes.push(item);
  });
  const pageNum = Math.ceil(newRes.length / 12);

  res1 = newRes.slice(0, 12);
  res10 = newRes.slice(12);

  newRes.map((item: any) => tempArea.push(item.city_area));
  areaArr = uniq(tempArea);
  // console.log('区域 -- ', areaArr);

  // page1
  areaArr.map((area: any) => {
    const temp: any[] = [];
    res1.map((city: any) => {
      if (city.city_area === area) {
        temp.push({
          city: city.city,
          diff: newRate(city.diff_index),
          rate: city.diff_index_change,
        });
      }
    });
    cityArr1.push({
      area: area,
      cityList: temp,
    });
  });

  cityArr1.map((item: any) => { if (item.cityList.length > 0) arr1.push(item); });

  const res11: any[] = [];
  for (let i = 0; i < pageNum - 1; i += 1) {
    const res12: any[] = res10.slice(13 * i, 13 * i + 13);
    res11.push(res12);
  }

  res11.map((arr: any) => {
    const areaArr: any[] = arr.map((item: any) => item.city_area);
    const res50: any[] = [];
    uniq(areaArr).map((area: any) => {
      const res51: any[] = [];
      arr.map((child: any) => {
        if (child.city_area === area) res51.push({
          city: child.city,
          diff: newRate(child.diff_index),
          rate: child.diff_index_change,
        });
      });
      res50.push({
        area: area,
        cityList: res51,
      });
    });
    lists.push(res50);
  });

  moDifferent.list1 = arr1;
  moDifferent.lists = lists;
});

export default moDifferent;
export { initDifferent };
